import { useEffect, useState } from 'react';
import axios from 'axios';
import Cookies from 'universal-cookie';
import config from '../../../../config';
import { useNavigate } from 'react-router-dom';
import { fetchCuestionarioById } from '../../api/cuestionariosApi';

const parseRespuestas = (value) => {
  if (!value) return {};
  if (typeof value === 'string') {
    try { return JSON.parse(value); } catch (_e) { return {}; }
  }
  return typeof value === 'object' ? value : {};
};

const CUESTIONARIO_INCONTINENCIA = 1;

export const useCuestionarioSPForm = ({ idPaciente, idCuestionario }) => {
  const cookies = new Cookies();
  const token = cookies.get('TOKEN');
  const API_URL = `https://${config.BACKEND}:${config.PORT}/cuestionario`;
  const navigate = useNavigate();
  const isEdit = Boolean(idCuestionario);

  const [frecuencia, setFrecuencia] = useState('');
  const [cantidad, setCantidad] = useState('');
  const [impactoVida, setImpactoVida] = useState(5);
  const [factores, setFactores] = useState([]);
  const [openGood, setOpenGood] = useState(false);

  useEffect(() => {
    if (!isEdit) return;
    fetchCuestionarioById(idCuestionario, idPaciente)
      .then((data) => {
        const r = parseRespuestas(data?.respuestas);
        setFrecuencia(r.frecuencia ?? '');
        setCantidad(r.cantidad ?? '');
        setImpactoVida(r.impactoVida ?? 5);
        setFactores(r.factores || []);
      })
      .catch((err) => console.error('Error fetching cuestionario SP:', err));
  }, [isEdit, idCuestionario, idPaciente]);

  const handleCheckboxChange = (e) => {
    const value = e.target.value;
    setFactores((prev) =>
      prev.includes(value) ? prev.filter((f) => f !== value) : [...prev, value]
    );
  };

  const guardarDatos = async () => {
    const datos = { frecuencia, cantidad, impactoVida, factores };
    const headers = { Authorization: `Bearer ${token}` };
    try {
      if (isEdit) {
        try {
          await axios.put(`${API_URL}/${idCuestionario}`, datos, { headers });
        } catch (err) {
          if (err.response?.status === 404) {
            await axios.post(`${API_URL}/${idCuestionario}`, datos, { headers });
          } else throw err;
        }
      } else {
        await axios.post(`${API_URL}/${idPaciente}/${CUESTIONARIO_INCONTINENCIA}`, datos, { headers });
      }
      setOpenGood(true);
      setTimeout(() => navigate(isEdit ? -1 : `/paciente/${idPaciente}`), 1500);
    } catch (err) {
      console.error('Error guardando cuestionario SP:', err);
    }
  };

  return {
    frecuencia, setFrecuencia,
    cantidad, setCantidad,
    impactoVida, setImpactoVida,
    factores, handleCheckboxChange,
    openGood, setOpenGood,
    isEdit,
    guardarDatos,
  };
};
